import React, { useLayoutEffect, useState } from 'react';
import { string } from 'prop-types';
import { FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import { NamedLink } from '../../components';
import allianzLogo from './AllianzLogo.png';
import IconHourGlass from '../LocationAutocompleteInput/IconHourGlass';
import css from './SectionHero.module.css';

function useWindowSize() {
  const [size, setSize] = useState([0, 0]);
  useLayoutEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight]);
    }
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);
  return size;
}

const SectionHero = props => {
  const [modalOpen, setModalOpen] = useState(false);

  const { rootClassName, className, mobileSearchInputsComponent } = props;
  const [width, height] = useWindowSize();
  const classes = classNames(rootClassName || css.root, className);

  const toogleModal = () => {
    setModalOpen(true);
  };
  return (
    <div className={classes}>
      <div className={css.heroContent}>
        {width < 800 && !modalOpen ? (
          <div className={css.dummySearchImput} onClick={toogleModal}>
            Où allez-vous ?{' '}
            <button className={css.searchButtonIcon}>
              <IconHourGlass />
            </button>
          </div>
        ) : null}

        <h2 className={css.heroMainTitleUp}>Stationnez autrement</h2>
        <h2 className={css.heroMainTitleDown}>
          <span className={css.lowerFontWeight}>Ici, </span>
          <span className={css.blueText}>
            <FormattedMessage id="SectionHero.title" />
          </span>
          <span className={css.lowerFontWeight}>
            {' '}
            <span className={css.lowerFontWeight}>à la journée,</span> à la semaine, au mois
          </span>
        </h2>
        <h2 className={css.heroMainTitleDown}>
          ⚠️ site en maintenance pendant 24h à 48h , si vous souhaitez réserver ou avez une question
          sur une réservation en cours ou à venir contacter +33648543088 ou contact@ollo.best
        </h2>
        <h2 className={css.heroSubTitle}>
          <FormattedMessage id="SectionHero.subTitle" />
          <img src={allianzLogo} className={css.allianzLogo} />
        </h2>
        {/* <NamedLink
                name="SearchPage"
                to={{
                  search:
                    'address=Finland&bounds=70.0922932%2C31.5870999%2C59.693623%2C20.456500199999937',
                }}
                className={css.heroButton}
              >
                <FormattedMessage id="SectionHero.browseButton" />
              </NamedLink> */}
        {modalOpen ? (
          <>
            <div className={css.blurryBackground} onClick={() => setModalOpen(false)}></div>
            <div className={css.mobileHeroSection}>
              <span className={css.closeButton} onClick={() => setModalOpen(false)}>
                FERMER X
              </span>
              {mobileSearchInputsComponent}
            </div>
          </>
        ) : null}
      </div>
    </div>
  );
};

SectionHero.defaultProps = { rootClassName: null, className: null };

SectionHero.propTypes = {
  rootClassName: string,
  className: string,
};

export default SectionHero;
